import { render, staticRenderFns } from "./SlotCounterStationPlatformPromotion.vue?vue&type=template&id=7107fab2&"
import script from "./SlotCounterStationPlatformPromotion.vue?vue&type=script&lang=js&"
export * from "./SlotCounterStationPlatformPromotion.vue?vue&type=script&lang=js&"
import style0 from "./SlotCounterStationPlatformPromotion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7107fab2')) {
      api.createRecord('7107fab2', component.options)
    } else {
      api.reload('7107fab2', component.options)
    }
    module.hot.accept("./SlotCounterStationPlatformPromotion.vue?vue&type=template&id=7107fab2&", function () {
      api.rerender('7107fab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Counter/SlotCounterStationPlatformPromotion.vue"
export default component.exports